const menu = document.querySelector(".menu");
const menuBig = document.querySelector(".menu__big");
const menuList = document.querySelector(".menu__list");
const menuProducts = document.querySelector(".menu__bigproducts");
const body = document.querySelector("body");
const menuSubtitleBlock = document.querySelectorAll(".menu__subtitle_block");
const stylesLink = document.querySelectorAll(".styles__link");
const stylesImg = document.querySelectorAll(".styles__img");
const overlay = document.querySelector(".overlay");
const styles = document.querySelector(".styles");
const arrows = document.querySelector(".arrows");
const modal = document.querySelector(".modal");
const modalWrapper = document.querySelector(".modal__wrapper");

export {
	menu,
	menuBig,
	menuList,
	menuProducts,
	body,
	menuSubtitleBlock,
	stylesLink,
	stylesImg,
	overlay,
	styles,
	arrows,
	modal,
	modalWrapper,
};
